import { API } from 'app/utils/client';
import { IProfession } from 'app/models';
import { CRUDService } from './api';

export class ProfessionService extends CRUDService<IProfession> { }

const instance = new ProfessionService(API, 'v1/professions');
export default instance;
